import gql from 'graphql-tag';

export default gql`
  mutation createOneCourseCategoryMutation($course: MongoID!) {
    createOneCourseCategoryMutation(course: $course) {
      record {
        _id
      }
    }
  }
`;
